import React from 'react';
import { Key } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter,
  DialogHeader, DialogTitle
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export default function ChangeRoleDialog({
  changeRoleUser,
  onClose,
  newRoleValue,
  setNewRoleValue,
  onSubmit,
  isSuperAdmin,
}) {
  return (
    <Dialog open={!!changeRoleUser} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Key size={18} className="text-purple-600" />
            Change Role
          </DialogTitle>
          <DialogDescription>
            Update role for <strong>{changeRoleUser?.name || changeRoleUser?.email}</strong>
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Select value={newRoleValue} onValueChange={setNewRoleValue}>
            <SelectTrigger data-testid="change-role-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {isSuperAdmin && <SelectItem value="super_admin">Super Admin</SelectItem>}
              <SelectItem value="org_admin">Org Admin</SelectItem>
              <SelectItem value="user">User</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={onSubmit} data-testid="confirm-change-role-btn">
            <Key size={14} className="mr-2" />
            Update Role
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
